module.exports = __webpack_public_path__ + "static/media/goldImg.09e8bae5.jpg";